/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import MainSection from 'types/MainSection';
import { ActionButton, AssetActionButton } from 'types/components/ActionButtonsGroup';
import { ActionButtonsGroup } from 'ui/components/';
import translate from '../../../services/i18n/translate';

interface Props {
  section: MainSection;
  actionButtons: (ActionButton | AssetActionButton)[];
}

interface SectionHeroDetails {
  [key: string]: {
    title: string;
    slogan?: string;
  };
}

const getSectionHeroDetails = (entryPoint: MainSection) => {
  const heroDetailsMap: SectionHeroDetails = {
    [MainSection.MY_TV]: {
      title: translate['mytv.mainContentTitle'],
      slogan: translate['mytv.slogan'],
    },
    [MainSection.WATCH_TV]: {
      title: translate['watchtv.notLoggedViewMiddleMessage'],
      slogan: translate['watchtv.notLoggedViewTopMessage'],
    },
    [MainSection.ONDEMAND]: {
      title: translate['menu.onDemand'],
    },
  };

  return heroDetailsMap[entryPoint];
};

function HomeHero({ section: entryPoint, actionButtons }: Props): JSX.Element {
  const heroDetails = getSectionHeroDetails(entryPoint);
  const welcomeText = translate['welcome.text'];

  return (
    <div className="hero-wrapper" id="HomeHero_wrapper">
      <div className="hero-overlay hero-text hero-centered">
        <div className="inner">
          <p id="HomeHero_slogan" className="top-message">
            {heroDetails.slogan}
          </p>
          <h1 id="HomeHero_title" className="homeHeroTitle">
            {heroDetails.title}
          </h1>
          {welcomeText ? (
            <p id="HomeHero_message" className="bottom-message">
              {welcomeText}
            </p>
          ) : (
            <></>
          )}
          {actionButtons ? <ActionButtonsGroup data={actionButtons} bemBlock="HomeHeroButtons" /> : null}
        </div>
      </div>
    </div>
  );
}

export default HomeHero;
